// extracted by mini-css-extract-plugin
module.exports = {"gradient":"SignIn_gradient_1BYGB"};